var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "width": "100%"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "9"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('statistics-common-filter', _vm._b({
    on: {
      "input": function ($event) {
        _vm.updatedCount = 0;
      }
    },
    model: {
      value: _vm.searchDateValue,
      callback: function ($$v) {
        _vm.searchDateValue = $$v;
      },
      expression: "searchDateValue"
    }
  }, 'statistics-common-filter', {
    loading: _vm.loading
  }, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('statistics-recruitment-applications', _vm._g(_vm._b({}, 'statistics-recruitment-applications', {
    searchDateValue: _vm.searchDateValue,
    loading: _vm.loading
  }, false), {
    updated: _vm.updated
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2",
    attrs: {
      "align": "stretch"
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('statistics-recruitment-workexperience', _vm._g(_vm._b({}, 'statistics-recruitment-workexperience', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('statistics-recruitment-languages', _vm._g(_vm._b({}, 'statistics-recruitment-languages', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('statistics-recruitment-certification', _vm._g(_vm._b({}, 'statistics-recruitment-certification', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('statistics-recruitment-residence', _vm._g(_vm._b({}, 'statistics-recruitment-residence', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2 flex-column"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('statistics-recruitment-recruitments', _vm._g(_vm._b({}, 'statistics-recruitment-recruitments', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('statistics-recruitment-consequences', _vm._g(_vm._b({}, 'statistics-recruitment-consequences', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }